import { render, staticRenderFns } from "./DomainPolicy.vue?vue&type=template&id=85453976&"
import script from "./DomainPolicy.vue?vue&type=script&lang=js&"
export * from "./DomainPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports